import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { refereeWindowMonths } from '@app/services/referral-program/referral-detail-timeline.util';
import { scrollTo } from '@app/utils/utils';

@Component({
  selector: 'referral-how-it-works',
  templateUrl: './referral-how-it-works.component.html',
  styleUrls: ['./referral-how-it-works.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralHowItWorksComponent {
  @Input({ required: true }) rewardAmount!: number;
  @Input({ required: true }) refereeWindowDays!: number;

  get bookingMonths() {
    return refereeWindowMonths(this.refereeWindowDays);
  }

  scrollToTerms(event: Event) {
    event.preventDefault();
    scrollTo('#referral-terms');
  }
}
